module.exports = __webpack_public_path__ + "static/media/DSC00419-3.7cc1d14e.jpg";